<template>
    <div class="container-fluid">
        
        <div class="row">
            <!-- <flag-chooser /> -->
            <div class="col-sm-12 text-center">
                <h2>ROCK ART</h2>
                <h4>
                Processamento de Imagens de Arte Rupestre
                </h4>
                <div class="logo-div">
                    <img :src="logo" alt="Rock Art logo" class="logo-image  mb-3">
                <!-- <h6>www.rockart.com.br</h6> -->
                </div>

            </div>      
        </div>
        
        

        <br/>

        <slot></slot>
    </div>
</template>

<script>
    import CustomFooter from './../components/CustomFooter';
    ///import { mapGetters } from 'vuex'
    //import Cookies from 'js-cookie';
    import LogoImage from './../assets/logo.png';
    import FlagChooser from './../components/FlagChooser';

    export default {
        name: 'AuthLogin',
        data(){
            return {
                logo: LogoImage
            }
        },
        components: {
            CustomFooter,
            FlagChooser
        },
    }
</script>

<style>
    h4{
        color: #790102;
    }

    .logo-div {
        border-bottom: 3px solid #790102; 
        border-top: 3px solid #790102; 
        padding-top: 0.5%;
    }

    .logo-image {
        height: 30vh;
        width: auto;
    }
</style>